export default __webpack_public_path__ + "static/media/samuel.035a79b1.jpeg";